import { render } from "./PpcSPProductAdItem.vue?vue&type=template&id=c9cbc46c&scoped=true"
import script from "./PpcSPProductAdItem.vue?vue&type=script&lang=js"
export * from "./PpcSPProductAdItem.vue?vue&type=script&lang=js"

import "./PpcSPProductAdItem.vue?vue&type=style&index=0&id=c9cbc46c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9cbc46c"]])

export default __exports__